import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from '../../../../../core/services/language.service';
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-vehicle-share-form',
  imports: [CommonModule],
  templateUrl: './vehicle-share-form.component.html',
  styleUrl: './vehicle-share-form.component.css'
})
export class VehicleShareFormComponent {
  currentLanguage: "TH" | "EN" = "TH";


  constructor(
    private router: Router,
    private languageService: LanguageService,
    private toastCustomService: ToastCustomService
  ) {
    this.languageService.currentLang$.subscribe(lang => {
      this.currentLanguage = lang;
    });
  }
  /* ------------------------------------ Function ------------------------------------ */
  /* --- Defualt ---*/
  goback() {
    this.router.navigate(['/vehicle-share']);
  }
  showWarning(text: string, detail: string = '') {
    // this.toast.warning(text);
    this.toastCustomService.showWarning('', text)
  }
  showError(text: string, detail: string = '') {
    // this.toast.error(text);
    this.toastCustomService.showError('', text)
  }
  showSuccess(text: string, detail: string = '') {
    // this.toast.success(text);
    this.toastCustomService.showSuccess('', text)
  }



  /* -------------------------------------- API ----------------------------------------- */

}
